/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "CC Transcript",
          "transcript": "Audio Transcript",
          "no_transcript": "Without subtitles"
        },
        "subtitle": "Subtitle",
        "show_subtitle": "Show Subtitle",
        "hide_subtitle": "Hide Subtitle"
      },
      "chapter": {
        "add": "Add a Chapter Marker"
      },
      "skip_fifteen_seconds": "Skip 15 Seconds",
      "play": {
        "speed_normal": "Normal",
        "speed": "Speed"
      },
      "back_fifteen_seconds": "Backward 15 Seconds",
      "skip_silence": "Skip Silence",
      "skip_to_next_speaker": "Skip to Next Speaker"
    }
  },
  "de-DE": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "CC Transkript",
          "transcript": "Audiotranskript",
          "no_transcript": "Ohne Untertitel"
        },
        "subtitle": "Untertitel",
        "show_subtitle": "Untertitel anzeigen",
        "hide_subtitle": "Untertitel ausblenden"
      },
      "chapter": {
        "add": "Kapitelmarkierung hinzuf\u00FCgen"
      },
      "skip_fifteen_seconds": "15 Sek. überspringen",
      "play": {
        "speed_normal": "Normal",
        "speed": "Geschwindigkeit"
      }
    }
  },
  "es-ES": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "Transcripci\u00F3n de subt\u00EDtulos",
          "transcript": "Transcripci\u00F3n de audio",
          "no_transcript": "Sin subtítulos"
        },
        "subtitle": "Subtítulo",
        "show_subtitle": "Mostrar subtítulo",
        "hide_subtitle": "Ocultar subtítulo"
      },
      "chapter": {
        "add": "Agregar un marcador de cap\u00EDtulo"
      },
      "skip_fifteen_seconds": "Saltar 15 segundos",
      "play": {
        "speed_normal": "Normal",
        "speed": "Velocidad"
      }
    }
  },
  "fr-FR": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "Transcription sous-titr\u00E9e",
          "transcript": "Transcription sonore",
          "no_transcript": "Sans sous-titres"
        },
        "subtitle": "Sous-titre",
        "show_subtitle": "Afficher les sous-titres",
        "hide_subtitle": "Masquer le sous-titrage"
      },
      "chapter": {
        "add": "Ajouter un marqueur de chapitre"
      },
      "skip_fifteen_seconds": "Ignorer 15 secondes",
      "play": {
        "speed_normal": "Normal",
        "speed": "Vitesse"
      }
    }
  },
  "id-ID": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "Transkrip CC",
          "transcript": "Transkrip Audio",
          "no_transcript": "Zonder ondertiteling"
        },
        "subtitle": "Ondertitel",
        "show_subtitle": "Tampilkan Subtitle",
        "hide_subtitle": "Sembunyikan Subtitle"
      },
      "chapter": {
        "add": "Tambah Penanda Bagian"
      },
      "skip_fifteen_seconds": "Lewati 15 Detik",
      "play": {
        "speed_normal": "Normal",
        "speed": "KECEPATAN"
      }
    }
  },
  "it-IT": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "Trascrizione ST",
          "transcript": "Trascrizione dell\u2019audio",
          "no_transcript": "Senza sottotitoli"
        },
        "subtitle": "Sottotitolo",
        "show_subtitle": "Mostra sottotitolo",
        "hide_subtitle": "Nascondi sottotitolo"
      },
      "chapter": {
        "add": "Aggiungi un contrassegno capitolo"
      },
      "skip_fifteen_seconds": "Salta 15 secondi",
      "play": {
        "speed_normal": "Normale",
        "speed": "Velocit\u00E0"
      }
    }
  },
  "jp-JP": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "CC\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30C8",
          "transcript": "\u97F3\u58F0\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30C8",
          "no_transcript": "サブタイトルなし"
        },
        "subtitle": "サブタイトル",
        "show_subtitle": "サブタイトルを表示",
        "hide_subtitle": "サブタイトルを非表示"
      },
      "chapter": {
        "add": "\u30C1\u30E3\u30D7\u30BF\u30DE\u30FC\u30AB\u30FC\u306E\u8FFD\u52A0"
      },
      "skip_fifteen_seconds": "15 秒スキップ",
      "play": {
        "speed_normal": "\u901A\u5E38",
        "speed": "\u901F\u5EA6"
      }
    }
  },
  "ko-KO": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "CC \uB300\uD654 \uB0B4\uC6A9",
          "transcript": "\uC624\uB514\uC624 \uB300\uD654 \uB0B4\uC6A9",
          "no_transcript": "자막 없음"
        },
        "subtitle": "자막",
        "show_subtitle": "자막 표시",
        "hide_subtitle": "자막 숨기기"
      },
      "chapter": {
        "add": "\uCC55\uD130 \uB9C8\uCEE4 \uCD94\uAC00"
      },
      "skip_fifteen_seconds": "15초 건너뛰기",
      "play": {
        "speed_normal": "\uBCF4\uD1B5",
        "speed": "\uC18D\uB3C4"
      }
    }
  },
  "nl-NL": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "CC-transcript",
          "transcript": "Audiotranscript",
          "no_transcript": "Zonder ondertiteling"
        },
        "subtitle": "Ondertitel",
        "show_subtitle": "Ondertitel weergeven",
        "hide_subtitle": "Ondertitel verbergen"
      },
      "chapter": {
        "add": "Een hoofdstukmarkering toevoegen"
      },
      "skip_fifteen_seconds": "15 seconden doorspoelen",
      "play": {
        "speed_normal": "Normaal",
        "speed": "SNELHEID"
      }
    }
  },
  "pl-PL": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "Transkrypcja CC",
          "transcript": "Transkrypcja audio",
          "no_transcript": "Bez napisów"
        },
        "subtitle": "Napisy",
        "show_subtitle": "Pokaż podtytuł",
        "hide_subtitle": "Ukryj podtytuł"
      },
      "chapter": {
        "add": "Dodaj znacznik rozdzia\u0142u"
      },
      "skip_fifteen_seconds": "Przewiń o 15 s",
      "play": {
        "speed_normal": "Normalna",
        "speed": "Szybko\u015B\u0107"
      }
    }
  },
  "pt-PT": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "Transcri\u00E7\u00E3o em CC",
          "transcript": "Transcri\u00E7\u00E3o do \u00E1udio",
          "no_transcript": "Sem legendas"
        },
        "subtitle": "Legenda",
        "show_subtitle": "Mostrar legenda",
        "hide_subtitle": "Ocultar legenda"
      },
      "chapter": {
        "add": "Adicionar um marcador de cap\u00EDtulo"
      },
      "skip_fifteen_seconds": "Pular 15 segundos",
      "play": {
        "speed_normal": "Normal",
        "speed": "Velocidade"
      }
    }
  },
  "ru-RU": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "\u0420\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0430 CC",
          "transcript": "\u0420\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0430 \u0430\u0443\u0434\u0438\u043E\u0441\u0432\u044F\u0437\u0438",
          "no_transcript": "Без субтитров"
        },
        "subtitle": "Субтитры",
        "show_subtitle": "Показать субтитры",
        "hide_subtitle": "Скрыть субтитры"
      },
      "chapter": {
        "add": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u0430\u0440\u043A\u0435\u0440 \u0433\u043B\u0430\u0432\u044B"
      },
      "skip_fifteen_seconds": "Перемотать на 15 секунд",
      "play": {
        "speed_normal": "\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u0430\u044F",
        "speed": "\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C"
      }
    }
  },
  "tr-TR": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "CC D\u00F6k\u00FCm\u00FC",
          "transcript": "Ses D\u00F6k\u00FCm\u00FC",
          "no_transcript": "Alt yazısız"
        },
        "subtitle": "Alt yazı",
        "show_subtitle": "Alt yazı göster",
        "hide_subtitle": "Alt yazıyı gizle"
      },
      "chapter": {
        "add": "B\u00F6l\u00FCm \u0130\u015Faret\u00E7isi ekle"
      },
      "skip_fifteen_seconds": "15 Saniye Atla",
      "play": {
        "speed_normal": "Normal",
        "speed": "H\u0131z"
      }
    }
  },
  "vi-VN": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "B\u1EA3n ch\u00E9p l\u1EA1i ph\u1EE5 \u0111\u1EC1 r\u1EDDi",
          "transcript": "B\u1EA3n ch\u00E9p l\u1EA1i \u00E2m thanh",
          "no_transcript": "Kh\u00F4ng c\u00F3 ph\u1EE5 \u0111\u1EC1"
        },
        "subtitle": "Ph\u1EE5 \u0111\u1EC1",
        "show_subtitle": "Hi\u1EC7n ph\u1EE5 \u0111\u1EC1",
        "hide_subtitle": "\u1EA8n ph\u1EE5 \u0111\u1EC1"
      },
      "chapter": {
        "add": "Th\u00EAm \u0111\u00E1nh d\u1EA5u ch\u01B0\u01A1ng"
      },
      "skip_fifteen_seconds": "Bỏ qua 15 giây",
      "play": {
        "speed_normal": "B\u00ECnh th\u01B0\u1EDDng",
        "speed": "T\u1ED1c \u0111\u1ED9"
      }
    }
  },
  "zh-CN": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "CC \u6587\u5B57\u8BB0\u5F55",
          "transcript": "\u8BED\u97F3\u8F6C\u6587\u5B57\u8BB0\u5F55",
          "no_transcript": "无字幕"
        },
        "subtitle": "字幕",
        "show_subtitle": "显示字幕",
        "hide_subtitle": "隐藏字幕"
      },
      "chapter": {
        "add": "\u6DFB\u52A0\u7AE0\u8282\u6807\u8BB0"
      },
      "skip_fifteen_seconds": "跳过15秒",
      "play": {
        "speed_normal": "\u6807\u51C6",
        "speed": "\u901F\u5EA6"
      }
    }
  },
  "zh-TW": {
    "recording": {
      "transcript": {
        "cc_name": {
          "cc_transcript": "CC \u6587\u5B57\u8A18\u9304",
          "transcript": "\u97F3\u8A0A\u6587\u5B57\u8A18\u9304",
          "no_transcript": "不含字幕"
        },
        "subtitle": "字幕",
        "show_subtitle": "顯示字幕",
        "hide_subtitle": "隱藏字幕"
      },
      "chapter": {
        "add": "\u65B0\u589E\u7AE0\u7BC0\u6A19\u8A18"
      },
      "skip_fifteen_seconds": "跳過15秒",
      "play": {
        "speed_normal": "\u6B63\u5E38",
        "speed": "\u901F\u5EA6"
      }
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
